<template lang="pug">
.form-contact-us-wrap
  v-form.form-contact-us(ref="form")
    v-text-field(
      :rules="[rules.required]",
      name="name",
      type="name",
      label="Nome",
      background-color="white",
      color="primary",
      outlined,
      dense
    )
    v-text-field(
      :rules="[rules.required, rules.email]",
      color="primary",
      name="email",
      type="email",
      label="E-mail",
      background-color="white",
      outlined,
      dense
    )
    v-text-field(
      v-mask="['(##) ####-####', '(##) #####-####']",
      :rules="[rules.required, rules.phone]",
      color="primary",
      outlined,
      dense,
      name="tel",
      type="tel",
      label="Telefone",
      background-color="white"
    )
    v-select(
      :items="staffSectors",
      :rules="[rules.required]",
      color="primary",
      name="sector",
      type="text",
      label="Setor",
      background-color="white",
      outlined,
      dense
    )
    v-textarea(
      :rules="[rules.required]",
      color="primary",
      name="text",
      type="text",
      label="Mensagem...",
      background-color="white",
      outlined,
      dense
    )
    v-btn.secondary.white--text(@click="submit", large, depressed) Enviar
    float-alert(:value="success", v-if="success", color="green") Sua mensagem foi enviada com sucesso.
    float-alert(:value="error", v-if="error", color="red") Aconteceu um erro ao enviar a mensagem.
  v-overlay(:value="loading")
    v-progress-circular(indeterminate, size="64")
</div>
</template>

<script>
import { mask } from "vue-the-mask";
import FloatAlert from "@/components/tools/FloatAlert";
import { required, email, phone } from "./rules";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    rules: {
      required,
      email,
      phone,
    },
    loading: false,
    error: false,
    success: false,
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.error = false;
        this.success = false;

        fetch(this.action, {
          method: "POST",
          body: new FormData(this.$refs.form.$el),
        })
          .then((r) => {
            if (r.ok) this.success = true;
            else throw new Error(r.status);
          })
          .catch(() => (this.error = true))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    staffSectors() {
      return this.$rest("staff").list.map(({ id, sector, name }) => ({
        text: sector + (name ? ": " + name : ""),
        value: id,
      }));
    },
  },
  directives: {
    mask,
  },
  components: {
    FloatAlert,
  },
};
</script>

<style>
.form-contact-us-wrap {
  width: max-content;
}
.form-contact-us {
  background: transparent;
  width: 100%;
  max-width: 400px;
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 10px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 7px;
}
@media screen and (min-width: 960px) {
  .form-contact-us {
    grid-template-columns: calc(50% - 16px) calc(50% - 16px);
  }
  .form-contact-us :nth-child(5),
  .form-contact-us :nth-child(6) {
    grid-column-end: span 2;
  }
}
.form-contact-us .v-alert {
  margin-top: 16px;
  font-size: 18px;
}
@media screen and (max-width: 960px) {
  .form-contact-us-wrap {
    width: 100%;
  }
}
</style>
